<div class="composer-with-dropdown">
  <div
    class="composer-field"
    [class.composer-field--disabled]="disabled"
    [class.composer-field--multiline]="multiline"
  >
    <div
      class="composer-shell"
      [class.composer-disabled]="disabled"
      (mousedown)="onComposerShellMouseDown($event)"
      (focusout)="onComposerFocusOut($event)"
      (keydown)="onComposerKeydown($event)"
    >
      <ng-container *ngFor="let part of composerParts; let i = index; trackBy: composerPartTrackBy">
        <textarea
          *ngIf="part.kind === 'text' && multiline"
          #composerTextInput
          rows="1"
          class="composer-text-input composer-text-input--multiline"
          [class.composer-text-input--leading-mention]="isLeadingSpacerBeforeMention(i)"
          [style.max-height]="multilineMaxHeight"
          [disabled]="disabled"
          [value]="part.text"
          enterkeyhint="send"
          (input)="onTextPartInput(i, $event)"
          (paste)="onTextPartPaste(i, $event)"
          [placeholder]="placeholder && isFirstTextPart(i) && isComposerEmpty() ? placeholderWithHint : ''"
          [attr.aria-label]="placeholder && isFirstTextPart(i) && isComposerEmpty() ? placeholderWithHint : null"
        ></textarea>
        <input
          *ngIf="part.kind === 'text' && !multiline"
          #composerTextInput
          type="text"
          class="composer-text-input"
          [class.composer-text-input--leading-mention]="isLeadingSpacerBeforeMention(i)"
          [disabled]="disabled"
          [value]="part.text"
          (input)="onTextPartInput(i, $event)"
          (paste)="onTextPartPaste(i, $event)"
          [placeholder]="placeholder && isFirstTextPart(i) && isComposerEmpty() ? placeholder : ''"
          [attr.aria-label]="placeholder && isFirstTextPart(i) && isComposerEmpty() ? placeholder : null"
        />
        <span
          *ngIf="part.kind === 'mention'"
          class="mention-chip"
          [class.mention-chip--pds]="appearance === 'pds'"
          [class.mention-chip-group]="part.entityType === 'group'"
        >
          <!-- The User model carries no photo, so app-avatar's initials are the avatar. Groups get
               the group icon instead, since initials of a team name read as a person. -->
          <ng-container *ngIf="appearance === 'pds'">
            <mat-icon *ngIf="part.entityType === 'group'" class="mention-chip-icon material-icons-outlined">group</mat-icon>
            <app-avatar *ngIf="part.entityType !== 'group'" class="mention-chip-avatar"
              [name]="part.label" [size]="18" [textSizeRatio]="18/8"></app-avatar>
          </ng-container>
          <span class="mention-chip-at" *ngIf="appearance !== 'pds'">@</span>
          <span class="mention-chip-label">{{ part.label }}</span>
          <button
            type="button"
            class="mention-chip-remove"
            [disabled]="disabled"
            (click)="removeMentionAt(i)"
            aria-label="Remove mention"
          >×</button>
        </span>
      </ng-container>
    </div>
    <button
      *ngIf="showSendButton"
      mat-icon-button
      type="button"
      class="composer-send"
      [disabled]="!canSend"
      [attr.aria-label]="canSend ? 'Send message' : 'Enter a message to send'"
      (click)="onSend()"
    >
      <mat-icon>{{ sendIcon }}</mat-icon>
    </button>
  </div>
  <div *ngIf="isMentionDropdownOpen" class="mentions-dropdown"
    [class.mentions-dropdown--pds]="appearance === 'pds'">
    <button
      type="button"
      class="mention-item"
      *ngFor="let item of mentionSuggestions; let i = index"
      [class.active]="i === activeMentionIndex"
      (mousedown)="selectMention(item)"
    >
      <ng-container *ngIf="appearance === 'pds'">
        <mat-icon *ngIf="item.type === 'group'" class="mention-item-icon material-icons-outlined">group</mat-icon>
        <app-avatar *ngIf="item.type !== 'group'" [name]="item.label" [size]="24" [textSizeRatio]="24/11"></app-avatar>
      </ng-container>
      <span class="mention-label">{{ item.label }}</span>
      <span *ngIf="item.secondary" class="mention-secondary">{{ item.secondary }}</span>
      <span class="mention-type">{{ item.type }}</span>
    </button>
  </div>
</div>
